<button class="syn-close-dialog" mat-icon-button (click)="cancel()">
  <mat-icon svgIcon="close"></mat-icon>
</button>

<h2 mat-dialog-title>
  Sauvegarder le filtre
</h2>

<mat-dialog-content>
  <mat-form-field fxFill appearance="outline" [style.padding-top]="'0.6rem'">
      <mat-label>Nom du filtre</mat-label>
      <input matInput [(ngModel)]="data.name" [required]="true" color="accent">
  </mat-form-field>
</mat-dialog-content>

<div mat-dialog-actions fxLayout="row" fxLayoutAlign="flex-end" fxLayoutGap="5px">
  <button mat-button (click)="cancel()">Annuler</button>
  <button mat-button [mat-dialog-close]="data.name" cdkFocusInitial color="primary">Sauvegarder</button>
</div>
